// @team BFA Acquisition
import flow from 'lodash/flow';
import React from 'react';

import ReferralGiftPopup from '../../features/Popups/pages/ReferralGift';
import { withApolloContext } from '../../utils/apollo';

const ReferralPage = () => <ReferralGiftPopup />;

const Cmp = flow(withApolloContext({ ssr: true }))(ReferralPage);

Cmp.displayName = 'Popup/Referral';

export default Cmp;
